import ContentBuilder from '../components/ContentBuilder'

export default function PageBuilder() {
  return <ContentBuilder entityType="page" />
}
